export interface VariantLike {
	type?: string;
	key?: string;
	namesMapKey?: string;
	generalSceneSlug?: string;
	generalAudioSlug?: string;
}

export interface VariantRefLike {
	slug: string;
	alt?: boolean;
	variant?: VariantLike;
}

const fallbackSlug = (v: VariantLike | null | undefined): string | undefined =>
	v?.generalSceneSlug ?? v?.generalAudioSlug;

/**
 * Writes `variant` onto a scene or audio ref and keeps `alt` on its general
 * (fallback) sibling in step. Without `alt: true` the player plays the fallback
 * next to the personalized ref instead of only when nothing matches.
 */
export function setRefVariant(
	siblings: VariantRefLike[],
	ref: VariantRefLike,
	variant: VariantLike | null,
): void {
	const previous = fallbackSlug(ref.variant);
	if (variant) ref.variant = variant;
	else delete ref.variant;
	const next = fallbackSlug(variant);
	if (previous === next) return;

	// Only drop alt that no other variant ref still relies on.
	if (previous && !siblings.some(s => fallbackSlug(s.variant) === previous)) {
		const old = siblings.find(s => s.slug === previous);
		if (old) delete old.alt;
	}
	const fallback = next ? siblings.find(s => s.slug === next && s !== ref) : undefined;
	if (fallback) fallback.alt = true;
}
